import { Pipe, PipeTransform } from '@angular/core';
import { formatRoundedDisplayValue } from '../utils/number-format.util';

@Pipe({
  name: 'roundToTenth',
  standalone: true,
})
export class RoundToTenthPipe implements PipeTransform {
  transform(value: unknown, locale?: string): string {
    return formatRoundedDisplayValue(value, locale);
  }
}
